import CambridgeModal, { CambridgeModalProps as ModalProps } from './Modal'
import './Modal.scss'

export type { ModalProps }
export default CambridgeModal